/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetFromJSON, AssetToJSON, CostLaborFromJSON, CostLaborToJSON, CostPartFromJSON, CostPartToJSON, DocumentFromJSON, DocumentToJSON, PerformoTaskFromJSON, PerformoTaskToJSON, WorkorderLogItemFromJSON, WorkorderLogItemToJSON, } from './';
export function WorkorderEditCommandFromJSON(json) {
    return WorkorderEditCommandFromJSONTyped(json, false);
}
export function WorkorderEditCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'pmScheduleId': !exists(json, 'pmScheduleId') ? undefined : json['pmScheduleId'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'assignToId': !exists(json, 'assignToId') ? undefined : json['assignToId'],
        'surveyId': !exists(json, 'surveyId') ? undefined : json['surveyId'],
        'assignTo': !exists(json, 'assignTo') ? undefined : json['assignTo'],
        'assignToSecondary': !exists(json, 'assignToSecondary') ? undefined : json['assignToSecondary'],
        'tradeTeam': !exists(json, 'tradeTeam') ? undefined : json['tradeTeam'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderByField2': !exists(json, 'orderByField2') ? undefined : json['orderByField2'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'photo': !exists(json, 'photo') ? undefined : json['photo'],
        'emailRequester': !exists(json, 'emailRequester') ? undefined : json['emailRequester'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'location3': !exists(json, 'location3') ? undefined : json['location3'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'requestType': !exists(json, 'requestType') ? undefined : json['requestType'],
        'orderStatus': !exists(json, 'orderStatus') ? undefined : json['orderStatus'],
        'closedOutFlag': !exists(json, 'closedOutFlag') ? undefined : json['closedOutFlag'],
        'orderCategory': !exists(json, 'orderCategory') ? undefined : json['orderCategory'],
        'overdueFlag': !exists(json, 'overdueFlag') ? undefined : json['overdueFlag'],
        'completedOrderFlag': !exists(json, 'completedOrderFlag') ? undefined : json['completedOrderFlag'],
        'reqFlag': !exists(json, 'reqFlag') ? undefined : json['reqFlag'],
        'openOrderFlag': !exists(json, 'openOrderFlag') ? undefined : json['openOrderFlag'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'jobPriority': !exists(json, 'jobPriority') ? undefined : json['jobPriority'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'privateNotes': !exists(json, 'privateNotes') ? undefined : json['privateNotes'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (json['startDateTime'] === null ? null : new Date(json['startDateTime'])),
        'entryDateTime': !exists(json, 'entryDateTime') ? undefined : (new Date(json['entryDateTime'])),
        'targetDateTime': !exists(json, 'targetDateTime') ? undefined : (json['targetDateTime'] === null ? null : new Date(json['targetDateTime'])),
        'completionDateTime': !exists(json, 'completionDateTime') ? undefined : (json['completionDateTime'] === null ? null : new Date(json['completionDateTime'])),
        'didNotCompleteDateTime': !exists(json, 'didNotCompleteDateTime') ? undefined : (json['didNotCompleteDateTime'] === null ? null : new Date(json['didNotCompleteDateTime'])),
        'assignedDateTime': !exists(json, 'assignedDateTime') ? undefined : (json['assignedDateTime'] === null ? null : new Date(json['assignedDateTime'])),
        'holdDateTime': !exists(json, 'holdDateTime') ? undefined : (json['holdDateTime'] === null ? null : new Date(json['holdDateTime'])),
        'deniedDateTime': !exists(json, 'deniedDateTime') ? undefined : (json['deniedDateTime'] === null ? null : new Date(json['deniedDateTime'])),
        'log': !exists(json, 'log') ? undefined : (json['log'] === null ? null : json['log'].map(WorkorderLogItemFromJSON)),
        'assets': !exists(json, 'assets') ? undefined : (json['assets'] === null ? null : json['assets'].map(AssetFromJSON)),
        'costParts': !exists(json, 'costParts') ? undefined : (json['costParts'] === null ? null : json['costParts'].map(CostPartFromJSON)),
        'costLabor': !exists(json, 'costLabor') ? undefined : (json['costLabor'] === null ? null : json['costLabor'].map(CostLaborFromJSON)),
        'procedureName': !exists(json, 'procedureName') ? undefined : json['procedureName'],
        'procedureText': !exists(json, 'procedureText') ? undefined : json['procedureText'],
        'procedureMandatoryFlag': !exists(json, 'procedureMandatoryFlag') ? undefined : json['procedureMandatoryFlag'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : json['tasks'].map(PerformoTaskFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : json['documents'].map(DocumentFromJSON)),
    };
}
export function WorkorderEditCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'workorderId': value.workorderId,
        'pmScheduleId': value.pmScheduleId,
        'contactId': value.contactId,
        'assignToId': value.assignToId,
        'surveyId': value.surveyId,
        'assignTo': value.assignTo,
        'assignToSecondary': value.assignToSecondary,
        'tradeTeam': value.tradeTeam,
        'propertyId': value.propertyId,
        'orderBy': value.orderBy,
        'orderByField2': value.orderByField2,
        'phoneNumber': value.phoneNumber,
        'photo': value.photo,
        'emailRequester': value.emailRequester,
        'building': value.building,
        'floor': value.floor,
        'suite': value.suite,
        'location3': value.location3,
        'jobType': value.jobType,
        'requestType': value.requestType,
        'orderStatus': value.orderStatus,
        'closedOutFlag': value.closedOutFlag,
        'orderCategory': value.orderCategory,
        'overdueFlag': value.overdueFlag,
        'completedOrderFlag': value.completedOrderFlag,
        'reqFlag': value.reqFlag,
        'openOrderFlag': value.openOrderFlag,
        'orderNumber': value.orderNumber,
        'jobPriority': value.jobPriority,
        'description': value.description,
        'notes': value.notes,
        'privateNotes': value.privateNotes,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime === null ? null : value.startDateTime.toISOString()),
        'entryDateTime': value.entryDateTime === undefined ? undefined : (value.entryDateTime.toISOString()),
        'targetDateTime': value.targetDateTime === undefined ? undefined : (value.targetDateTime === null ? null : value.targetDateTime.toISOString()),
        'completionDateTime': value.completionDateTime === undefined ? undefined : (value.completionDateTime === null ? null : value.completionDateTime.toISOString()),
        'log': value.log === undefined ? undefined : (value.log === null ? null : value.log.map(WorkorderLogItemToJSON)),
        'assets': value.assets === undefined ? undefined : (value.assets === null ? null : value.assets.map(AssetToJSON)),
        'costParts': value.costParts === undefined ? undefined : (value.costParts === null ? null : value.costParts.map(CostPartToJSON)),
        'costLabor': value.costLabor === undefined ? undefined : (value.costLabor === null ? null : value.costLabor.map(CostLaborToJSON)),
        'procedureName': value.procedureName,
        'procedureText': value.procedureText,
        'procedureMandatoryFlag': value.procedureMandatoryFlag,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : value.tasks.map(PerformoTaskToJSON)),
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : value.documents.map(DocumentToJSON)),
    };
}
